import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { TaskTimer, TaskTimerHistory } from '../../data-services/task-timer';
import { map } from 'rxjs/operators';
import { LoggingService } from '../../shared/services/logging';
import { Store, select } from '@ngrx/store';
import * as fromActions from '../store/task-timer.actions';
import * as fromReducer from '../store/task-timer.reducer';
import * as fromHistActions from '../store/timer-history/task-timer-history.actions';
import * as fromHistReducer from '../store/timer-history/task-timer-history.reducer';
import clone from 'just-clone';
import { Process } from '../../shared';
import * as fromShared from '../../shared';
import * as fromUserInfo from '../../user-info/store/user.reducer';
import { IUserInfo } from '../../user-info';
@Component({
    selector: 'ef-task-timer-feature',
    templateUrl: './task-timer-feature.component.html',
    styleUrls: ['./task-timer-feature.component.scss'],
    standalone: false
})
export class TaskTimerFeatureComponent implements OnInit {
    items$: Observable<TaskTimer[]>;
    timerHistory$: Observable<TaskTimerHistory[]>;
    process$: Observable<Process>;
    userInfo$: Observable<IUserInfo>;
    constructor(private log: LoggingService, private store: Store) {}

    ngOnInit(): void {
        this.store.dispatch(fromActions.getTaskTimer());
        this.setupObservables();
    }

    setupObservables() {
        this.process$ = this.store.pipe(select(fromShared.selectCurrent));
        this.userInfo$ = this.store.pipe(select(fromUserInfo.getUserInfo));
        this.items$ = this.store.pipe(
            select(fromReducer.selectAll),
            map(x => clone(x))
        );
        this.timerHistory$ = this.store.pipe(
            select(fromHistReducer.selectAll),
            map(x => clone(x))
        );
    }

    setupSubscriptions() {}

    onStartTimer(event) {
        this.store.dispatch(fromActions.putTaskTimer({ JsonString: event }));
    }
    onStopTimer(event) {
        this.store.dispatch(fromActions.putTaskTimer({ JsonString: event }));
    }
    onLoadTimerHistory(event) {
        this.store.dispatch(
            fromHistActions.postTaskTimerHistory({
                StartDate: event.StartDate,
                EndDate: event.EndDate
            })
        );
    }
    onUpdateTimerHistory(event) {
        const jsonstr = JSON.stringify(event);
        this.store.dispatch(
            fromActions.putTaskTimerHistory({
                JsonString: jsonstr,
                StartDate: event.HistoryStart,
                EndDate: event.HistoryEnd
            })
        );
    }
}
